import type { MathflatApi } from '@mathflat/domain/@entities/StudentExam/api2'
import type { DefaultResponse } from '@mathflat/shared/@types/mathflatApi'

import maxios from '../utils/maxios'

export const studentExamApi = (() => {
  return {
    getStudentExams: ({
      studentId,
      dateTime: { startDate, endDate },
    }: {
      studentId: string
      dateTime: {
        startDate: string
        endDate: string
      }
    }) => {
      return maxios.get<DefaultResponse<MathflatApi.Response.StudentExam[]>>(`/student-exam`, {
        params: {
          studentId,
          startDate,
          endDate,
        },
      })
    },
  }
})()
